import { render, staticRenderFns } from "./lcIndex.vue?vue&type=template&id=61477cef&scoped=true&"
import script from "./lcIndex.vue?vue&type=script&lang=js&"
export * from "./lcIndex.vue?vue&type=script&lang=js&"
import style0 from "./lcIndex.vue?vue&type=style&index=0&id=61477cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61477cef",
  null
  
)

export default component.exports